import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ImagesCard.css';

function ImagesCard() {
    const { t } = useTranslation();

    return (
        <div className='img-cards'>
            <div className='first-component'>
                <h5 style={{ color: '#F6F7F8', margin: 0 }}>{t('Transition to Prostay made Simple!')}</h5>
                <p className='body-small'>
                    {t('Migrating to a new platform should be simple. Our data migration team will ensure a smooth and efficient transition from any system you are using, with full data import, reservations transfer, and system configuration.')}
                </p>
                <img src='/images/first-img-component.png' alt={"Transition to Prostay"} />
            </div>
            <div className='second-component' style={{ backgroundImage: 'url(/images/second-img-component.png)' }}>
                <h5 style={{ color: '#22242A', margin: 0 }}>
                    {t('We’re With You From Day One')}
                </h5>
                <p className='body-small'>
                    {t('Getting started with Prostay is easy. Our team will guide you through personalized onboarding sessions—from system setup and rate configuration to hands-on training for your staff—so your team can hit the ground running with confidence.')}
                </p>
                <p className='body-small'>
                    {t('We listen closely to every hotel we work with. Whether you need a feature tailored to your unique operation or have an idea that could benefit the entire Prostay community, we welcome your requests. Our development team evaluates every suggestion—and when it makes sense, we build it just for you or roll it out for everyone.')}
                </p>
            </div>
            <div className='third-component' style={{ backgroundImage: 'url(/images/third-img-component.png)' }}>
                <h5 style={{ color: '#F6F7F8', margin: 0 }}>
                    {t('We’re here for you 24/7/365')}
                </h5>
                <p className='body-small'>
                    {t('Non-stop, lightning fast customer support.')}
                </p>
            </div>
        </div>
    );
}

export default ImagesCard;